import { z } from "zod";
const id = z.string().min(1).max(240);
const digest = z.string().regex(/^[a-f0-9]{64}$/u);
export const customerEditFamilyV1Schema = z.enum([
    "BEDTIME",
    "MY_STORY",
    "OUR_STORY",
    "COOKBOOK",
    "COMIC",
]);
export const customerEditIntentV1Schema = z.enum([
    "SAVE_TEXT",
    "APPROVE_SOURCE",
    "COMPILE",
    "RENDER_PROOF",
    "APPROVE_EDITION",
    "RESTORE_SOURCE",
]);
export const customerEditSourceUnitKindV1Schema = z.enum([
    "STORY_MANUSCRIPT",
    "CHAPTER",
    "RECIPE",
    "SCRIPT",
]);
export const customerEditAdmissionRequestV1Schema = z
    .object({
    family: customerEditFamilyV1Schema,
    intent: customerEditIntentV1Schema,
    unitId: id.optional(),
    sourceUnitKind: customerEditSourceUnitKindV1Schema.optional(),
    originalOperationKey: z.string().min(16).max(128).optional(),
})
    .strict();
export const customerEditAdmissionV1Schema = z
    .object({
    contract: z.literal("LC_CUSTOMER_EDIT_ADMISSION_V1"),
    bookId: id,
    family: customerEditFamilyV1Schema,
    intent: customerEditIntentV1Schema,
    source: z
        .object({
        kind: customerEditSourceUnitKindV1Schema,
        unitId: id,
        artifactId: id.nullable(),
        currentRevision: z.union([z.number().int().nonnegative(), id]).nullable(),
        basisDigestSha256: digest,
    })
        .strict()
        .nullable(),
    decision: z.enum(["ALLOWED", "ALLOWED_MAKES_EDITION_STALE", "LOCKED"]),
    reasonCode: z.enum([
        "READY",
        "EDIT_WILL_STALE_ACCEPTED_EDITION",
        "ORDERED_EDITION_IMMUTABLE",
        "SOURCE_UNIT_UNAVAILABLE",
        "FAMILY_MISMATCH",
        "LEGACY_SOURCE_EVIDENCE_UNAVAILABLE",
        "BEDTIME_APPROVED_MANUSCRIPT_LOCKED",
        "ORIGINAL_OPERATION_RECONCILIATION_REQUIRED",
    ]),
    nextAction: z.enum([
        "CONTINUE",
        "RELOAD_CURRENT_SOURCE",
        "RELOAD_ORIGINAL_OPERATION",
        "START_NEW_STORY_REVISION",
        "CONTACT_SUPPORT",
    ]),
    expectedRevision: z.union([z.number().int().nonnegative(), id]).nullable(),
    relation: z
        .object({
        accepted: z.object({ editionId: id, proofId: id.nullable() }).strict().nullable(),
        ordered: z.object({ physicalOrderId: id, editionId: id }).strict().nullable(),
        currentProof: z.object({ proofId: id }).strict().nullable(),
    })
        .strict(),
    originalOperation: z
        .object({
        state: z.enum(["NOT_REQUESTED", "NOT_OBSERVED", "RECORDED", "UNKNOWN", "CONFLICT"]),
        canReconcile: z.boolean(),
    })
        .strict(),
    reconcilableOperation: z.boolean(),
    mutationRecheckErrorCode: z.literal("BOOK_EDIT_ADMISSION_CHANGED"),
    truthBoundary: z.literal("READ_DOES_NOT_GRANT_MUTATION_APPROVAL_ENTITLEMENT_OR_PERMISSION_TO_PRINT"),
})
    .strict();
export const customerEditAdmissionListV1Schema = z
    .object({
    contract: z.literal("LC_CUSTOMER_EDIT_ADMISSION_LIST_V1"),
    bookId: id,
    family: customerEditFamilyV1Schema,
    intent: customerEditIntentV1Schema,
    units: z.array(customerEditAdmissionV1Schema).max(200),
    coverage: z
        .object({
        state: z.enum(["COMPLETE", "SOURCE_EVIDENCE_UNAVAILABLE"]),
        reasonCode: z.enum(["READY", "LEGACY_SOURCE_EVIDENCE_UNAVAILABLE"]),
    })
        .strict(),
    truthBoundary: z.literal("LIST_DOES_NOT_GRANT_MUTATION_APPROVAL_ENTITLEMENT_OR_PERMISSION_TO_PRINT"),
})
    .strict();
//# sourceMappingURL=book-edit-admission.js.map